import { createSlice } from '@reduxjs/toolkit';
import { fetchOfficeHours, fetchUpdateOfficeHours } from '../../../store/Practice/OfficeHours/OfficeHoursActions';
import { getApiErrorMessage } from '../../../utils/commonUtilities';

const fetchOfficeHoursSlice = createSlice({
    name: 'fetchOfficeHours',
    initialState: {
        isOfficeHoursLoading: false,
        officeHoursError: null,
        officeHoursErrorMsg: '',
        data: {},
    },
    reducers: {
        setOfficeHours: (state, action) => {
            state.data = { ...state.data, ...action.payload };
        },
        updateOfficeHour: (state, action) => {
            const { day, officeOpen, officeClose, limited } = action.payload;
            if (!state.data[day]) {
                state.data[day] = {
                    officeOpen: '',
                    officeClose: '',
                    limited: false,
                };
            }
            if (officeOpen !== undefined) state.data[day].officeOpen = officeOpen;
            if (officeClose !== undefined) state.data[day].officeClose = officeClose;
            if (limited !== undefined) state.data[day].limited = limited;
        },
        clearErrors: (state) => {
            state.officeHoursError = null;
            state.officeHoursErrorMsg = '';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchOfficeHours.pending, (state) => {
                state.isOfficeHoursLoading = true;
                state.officeHoursError = null;
                state.officeHoursErrorMsg = '';
            })
            .addCase(fetchOfficeHours.fulfilled, (state, action) => {
                state.isOfficeHoursLoading = false;
                if (action.payload.metadata && action.payload.metadata?.outcome && action.payload.metadata?.outcome.status !== 200) {
                    state.officeHoursError = true;
                    state.officeHoursErrorMsg = getApiErrorMessage(action.payload.metadata?.outcome.status);
                } else {
                    state.officeHoursError = false;
                    state.data = action.payload;
                }
            })
            .addCase(fetchOfficeHours.rejected, (state) => {
                state.isOfficeHoursLoading = false;
                state.officeHoursError = true;
                state.officeHoursErrorMsg = "Something Went Wrong!. Please try again later.";
            })
    },
});

const updateOfficeHoursSlice = createSlice({
    name: 'updateOfficeHours',
    initialState: {
        isUpdateOfficeHoursLoading: false,
        updateOfficeHoursError: null,
        updateOfficeHoursErrorMsg: '',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchUpdateOfficeHours.pending, (state) => {
                state.isUpdateOfficeHoursLoading = true;
                state.updateOfficeHoursError = null;
                state.updateOfficeHoursErrorMsg = '';
            })
            .addCase(fetchUpdateOfficeHours.fulfilled, (state, action) => {
                state.isUpdateOfficeHoursLoading = false;
                if (action.payload.metadata && action.payload.metadata?.outcome && action.payload.metadata?.outcome.status !== 200) {
                    state.updateOfficeHoursError = true;
                    state.updateOfficeHoursErrorMsg = getApiErrorMessage(action.payload.metadata?.outcome.status);
                } else {
                    state.updateOfficeHoursError = false;
                }
            })
            .addCase(fetchUpdateOfficeHours.rejected, (state) => {
                state.isUpdateOfficeHoursLoading = false;
                state.updateOfficeHoursError = true;
                state.updateOfficeHoursErrorMsg = "Something Went Wrong!. Please try again later.";
            });
    },
});

export const { setOfficeHours, updateOfficeHour, clearErrors } = fetchOfficeHoursSlice.actions;
export const officeHoursReducer = fetchOfficeHoursSlice.reducer;
export const updateOfficeHoursReducer = updateOfficeHoursSlice.reducer;
